import { queryClient } from "./queryClient";

export const USER_ID = "@userControllID";
export const TOKEN_KEY = "@walletLoteToken";
export const ROLE_CONTROLL = "@roleControll";
export const USER_CONTROLL = "@userControll";
export const ENVIRONMENT_CONTROLL = "@environmentControll";
export const PROFILE_PHOTO = "@profilePhoto";
export const STATUS_CONTROLL = "@statusControll";
export const IS_IB3 = "@isIB3";
export const IS_TRIAL = "@isTrial";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getUserId = () => localStorage.getItem(USER_ID);
export const getUserRole = () => localStorage.getItem(ROLE_CONTROLL);
export const getUserName = () => localStorage.getItem(USER_CONTROLL);
export const getEnvironment = () => localStorage.getItem(ENVIRONMENT_CONTROLL);
export const getProfilePhoto = () => localStorage.getItem(PROFILE_PHOTO);
export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getStatusAccount = () => localStorage.getItem(STATUS_CONTROLL);
export const getIsIB3 = () => localStorage.getItem(IS_IB3) === "false" ? false : true;
export const getIsTrial = () => localStorage.getItem(IS_TRIAL);

export const login = (token, usuario, user_id, role, photo, isIB3, isTrial, environment) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_ID, user_id);
  localStorage.setItem(ROLE_CONTROLL, role);
  localStorage.setItem(PROFILE_PHOTO, photo);
  localStorage.setItem(USER_CONTROLL, usuario);
  localStorage.setItem(ENVIRONMENT_CONTROLL, environment);
  localStorage.setItem(IS_IB3, isIB3 ? isIB3 : false);
  localStorage.setItem(IS_TRIAL, isTrial);
};

export const statusAccount = (status) => {
  localStorage.setItem(STATUS_CONTROLL, status);
};

export const logout = () => {
  localStorage.removeItem(USER_ID);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_CONTROLL);
  localStorage.removeItem(PROFILE_PHOTO);
  localStorage.removeItem(IS_IB3);
  localStorage.removeItem(IS_TRIAL);
  localStorage.removeItem(ROLE_CONTROLL);
  localStorage.removeItem(ENVIRONMENT_CONTROLL);
  queryClient.clear();
  const dark = localStorage.getItem('appDarkMode')
  localStorage.clear();
  localStorage.setItem('appDarkMode', dark);
};